const MAX_FILL_REPEATS = 20;

function updateLogosMarquees() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  $('.jb-logos-marquee-container').each(function () {
    const containerElement = $(this);
    const marquee = $('.jb-logos-marquee', containerElement);
    const lists = $('.jb-logos-marquee-list', marquee);
    const firstList = lists.first();

    if (!marquee.length || !firstList.length) {
      return;
    }

    $('.jb-logos-marquee-clone', marquee).remove();

    const originalItems = $('.jb-logos-item', firstList);

    if (!originalItems.length || reducedMotion) {
      marquee.addClass('jb-logos-marquee-static');
      return;
    }

    marquee.removeClass('jb-logos-marquee-static');

    let repeats = 0;
    while (firstList[0].scrollWidth <= containerElement[0].clientWidth && repeats < MAX_FILL_REPEATS - 1) {
      lists.each(function () {
        const spacer = $('.jb-logos-marquee-spacer', this);

        originalItems
          .clone()
          .addClass('jb-logos-marquee-clone')
          .attr('aria-hidden', 'true')
          .insertBefore(spacer);
      });

      repeats++;
    }

    marquee.toggleClass('jb-logos-marquee-static', firstList[0].scrollWidth <= containerElement[0].clientWidth);
  });
}

function onLogosMarqueeInitOrRender() {
  updateLogosMarquees();
}

document.addEventListener('DOMContentLoaded', onLogosMarqueeInitOrRender);
document.addEventListener('jb.section.rendered', onLogosMarqueeInitOrRender);
document.addEventListener('section.initiated', onLogosMarqueeInitOrRender);
window.addEventListener('load', onLogosMarqueeInitOrRender);
window.addEventListener('resize', onLogosMarqueeInitOrRender);
